module.exports = __webpack_public_path__ + "img/writingSeminar_041022_H.e092545c.jpg";